module.exports = __webpack_public_path__ + "img/inu_gallery12.e487dc69.jpg";